import { UserInfo } from '@Entities/user/user'
import { USER_FORM } from '@Const/forms-constants'
import React from 'react'

interface ContactInfoSectionProps {
    userInfo: UserInfo
    phoneNumberTitle: string
}
const ContactInfoSection = (props: ContactInfoSectionProps) => {
    const { userInfo, phoneNumberTitle } = props
    return (
        <section className="contact-info-section">
            <h5>Contact Information</h5>
            <div className="fields-row-container">
                <div className="field-block">
                    <p className="small title">{USER_FORM.phoneNumber.label}</p>
                    <p className="value">{phoneNumberTitle}</p>
                </div>
                <div className="field-block">
                    <p className="small title">{USER_FORM.email.label}</p>
                    <p className="value">{userInfo.email}</p>
                </div>
            </div>
        </section>
    )
}
export default ContactInfoSection
